import { db } from '../config/firebase-config';
import { collection, query, where, orderBy, onSnapshot, addDoc, doc, updateDoc, getDocs, serverTimestamp } from 'firebase/firestore';

// Real-time subscription to active subscribers, ordered by subscribedAt desc
export function getSubscribers(practitionerId, callback) {
  const q = query(
    collection(db, 'practitioners', practitionerId, 'subscribers'),
    where('status', '==', 'active'),
    orderBy('subscribedAt', 'desc')
  );
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  });
}

// Count of active subscribers
export async function getSubscriberCount(practitionerId) {
  const q = query(
    collection(db, 'practitioners', practitionerId, 'subscribers'),
    where('status', '==', 'active')
  );
  const snap = await getDocs(q);
  return snap.size;
}

// Add subscriber manually (from dashboard)
export async function addSubscriberManually(practitionerId, { email, firstName = null, lastName = null }) {
  const emailLower = email.toLowerCase().trim();
  // Check for existing
  const q = query(
    collection(db, 'practitioners', practitionerId, 'subscribers'),
    where('email', '==', emailLower)
  );
  const existing = await getDocs(q);
  if (!existing.empty) {
    const docRef = existing.docs[0].ref;
    await updateDoc(docRef, { status: 'active', subscribedAt: serverTimestamp() });
    return existing.docs[0].id;
  }
  const ref = await addDoc(collection(db, 'practitioners', practitionerId, 'subscribers'), {
    email: emailLower,
    subscribedAt: serverTimestamp(),
    source: 'manual',
    status: 'active',
    unsubscribedAt: null,
    firstName,
    lastName,
    metadata: { firstBookingDate: null, isClient: false }
  });
  return ref.id;
}

// Soft-delete (compliance — never hard delete)
export async function removeSubscriber(practitionerId, subscriberId) {
  await updateDoc(doc(db, 'practitioners', practitionerId, 'subscribers', subscriberId), {
    status: 'unsubscribed',
    unsubscribedAt: serverTimestamp()
  });
}

// Returns array of active subscriber objects for CSV export
export async function exportSubscribers(practitionerId) {
  const q = query(
    collection(db, 'practitioners', practitionerId, 'subscribers'),
    where('status', '==', 'active')
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
